export class ErrorFactory {
  static createActionNotImplemented(action: string) {
    return new Error(`'${action}' action not implemented`)
  }

  static createPortalNotFound(name: string) {
    return new Error(`Portal "${name}" not found`)
  }
}
